import { NgModule } from '@angular/core';

import { MaterialModule } from '../../modules/material.module';
import { SharedModule } from '../../modules/shared.module';
import { PopupComponent } from './popup.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule
  ],
  declarations: [
    PopupComponent
  ],
  exports: [
    PopupComponent
  ]
})
export class PopupModule {}
